import { __assign, __extends } from "tslib";
// @flow
import React, { Component } from "react";
import { Text, View, TouchableOpacity, ScrollView } from "react-native";
import PropTypes from "prop-types";
import styles from "./PnmacNavPanel.styles.js";
import Hoverable from "../Hoverable.js";
var PnmacNavPanel = /** @class */function (_super) {
  __extends(PnmacNavPanel, _super);
  function PnmacNavPanel() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.render = function () {
      var _a = _this.props,
        listItems = _a.listItems,
        listItemStyles = _a.listItemStyles,
        textItemContainerStyles = _a.textItemContainerStyles,
        textItemStyles = _a.textItemStyles,
        subTextItemStyles = _a.subTextItemStyles,
        containerStyles = _a.containerStyles,
        onListItemClick = _a.onListItemClick,
        selectedStyles = _a.selectedStyles,
        selectedContainerStyles = _a.selectedContainerStyles,
        selected = _a.selected,
        inlineDisplay = _a.inlineDisplay,
        hoverColor = _a.hoverColor;
      return /*#__PURE__*/React.createElement(ScrollView, {
        style: __assign(__assign({}, styles.containerStyles), containerStyles),
        testID: "navPanel"
      }, listItems.map(function (s, i) {
        var picked = selected && s.route == selected ? selectedStyles : {};
        var pickedContainer = selected && s.route == selected ? selectedContainerStyles : {};
        return /*#__PURE__*/React.createElement(ExHov, __assign({}, _this.props, {
          hoverColor: hoverColor,
          key: i,
          inlineDisplay: inlineDisplay,
          mainStyles: __assign(__assign(__assign({}, styles.listItemStyles), listItemStyles), pickedContainer),
          data: s,
          style: __assign(__assign({}, styles.inlineDisplay), inlineDisplay),
          textStyle: __assign(__assign(__assign(__assign({}, styles.textItemStyles), textItemStyles), subTextItemStyles), picked),
          onPress: onListItemClick
        }));
      }));
    };
    return _this;
  }
  PnmacNavPanel.propTypes = {
    listItems: PropTypes.array.isRequired,
    listItemStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
    textItemContainerStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
    textItemStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
    subTextItemStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
    containerStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
    toggleIcon: PropTypes.any,
    subListItemStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
    selected: PropTypes.string,
    selectedStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string]),
    selectedContainerStyles: PropTypes.oneOfType([PropTypes.array, PropTypes.object, PropTypes.string])
  };
  return PnmacNavPanel;
}(Component);
var ExHov = /** @class */function (_super) {
  __extends(ExHov, _super);
  function ExHov() {
    var _this = _super !== null && _super.apply(this, arguments) || this;
    _this.state = {
      hovering: false
    };
    return _this;
  }
  ExHov.prototype.render = function () {
    var _this = this;
    var _a = this.props,
      onPress = _a.onPress,
      style = _a.style,
      textStyle = _a.textStyle,
      data = _a.data,
      mainStyles = _a.mainStyles,
      inlineDisplay = _a.inlineDisplay,
      hoverColor = _a.hoverColor;
    return !data.canExpand ? (/*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({}, mainStyles), {
        backgroundColor: this.state.hovering ? hoverColor || "#efefef" : mainStyles.backgroundColor
      })
    }, /*#__PURE__*/React.createElement(Hoverable, {
      onHoverIn: function () {
        return _this.setState({
          hovering: true
        });
      },
      onHoverOut: function () {
        return _this.setState({
          hovering: false
        });
      }
    }, /*#__PURE__*/React.createElement(TouchableOpacity, {
      style: __assign({}, style),
      onPress: function () {
        return onPress(data);
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: textStyle
    }, data.name))))) : (/*#__PURE__*/React.createElement(ExpandableItem, __assign({
      obj: data
    }, this.props, {
      mainStyles: mainStyles,
      hoverColor: hoverColor,
      listItems: data.subList,
      inlineDisplay: inlineDisplay
    })));
  };
  return ExHov;
}(React.Component);
var ExpandableItem = /** @class */function (_super) {
  __extends(ExpandableItem, _super);
  function ExpandableItem(props) {
    var _this = this;
    var _a;
    _this = _super.call(this, props) || this;
    _this.state = {
      expanded: ((_a = props.defaultExpanded) === null || _a === void 0 ? void 0 : _a.find(function (e) {
        var _a;
        return e == ((_a = props.obj) === null || _a === void 0 ? void 0 : _a.name);
      })) ? true : false,
      hovering: false
    };
    return _this;
  }
  ExpandableItem.prototype.render = function () {
    var _this = this;
    var expanded = this.state.expanded;
    var _a = this.props,
      listItemStyles = _a.listItemStyles,
      textItemStyles = _a.textItemStyles,
      subTextItemStyles = _a.subTextItemStyles,
      onListItemClick = _a.onListItemClick,
      obj = _a.obj,
      subListItemStyles = _a.subListItemStyles,
      toggleIcon = _a.toggleIcon,
      selectedStyles = _a.selectedStyles,
      selectedContainerStyles = _a.selectedContainerStyles,
      selected = _a.selected,
      inlineDisplay = _a.inlineDisplay,
      hoverColor = _a.hoverColor,
      mainStyles = _a.mainStyles;
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TouchableOpacity, {
      onPress: function () {
        return _this.setState({
          expanded: !expanded
        });
      }
    }, /*#__PURE__*/React.createElement(Hoverable, {
      onHoverIn: function () {
        return _this.setState({
          hovering: true
        });
      },
      onHoverOut: function () {
        return _this.setState({
          hovering: false
        });
      }
    }, /*#__PURE__*/React.createElement(View, {
      style: __assign(__assign({}, mainStyles), {
        backgroundColor: this.state.hovering ? hoverColor || "#efefef" : null
      })
    }, /*#__PURE__*/React.createElement(View, {
      style: {
        display: "flex",
        flexDirection: "row"
      }
    }, /*#__PURE__*/React.createElement(Text, {
      style: __assign(__assign({}, styles.textItemStyles), textItemStyles)
    }, obj.name), toggleIcon ? (/*#__PURE__*/React.createElement(View, {
      style: toggleIcon.styles
    }, expanded ? toggleIcon.imageDown : toggleIcon.imageUp)) : null)))), expanded && (/*#__PURE__*/React.createElement(View, {
      style: subListItemStyles
    }, obj.subList.map(function (s, i) {
      var picked = selected && s.route == selected ? selectedStyles : {};
      var pickedContainer = selected && s.route == selected ? selectedContainerStyles : {};
      return /*#__PURE__*/React.createElement(ExHov, __assign({
        key: i
      }, _this.props, {
        hoverColor: hoverColor,
        mainStyles: __assign(__assign(__assign({}, styles.listItemStyles), listItemStyles), pickedContainer),
        data: s,
        style: __assign(__assign({}, styles.inlineDisplay), inlineDisplay),
        textStyle: __assign(__assign(__assign(__assign({}, styles.textItemStyles), textItemStyles), subTextItemStyles), picked),
        onPress: onListItemClick
      }));
    }))));
  };
  return ExpandableItem;
}(React.Component);
export default PnmacNavPanel;